import TablePagination from '../component/TablePagination';
import { brand } from "../config/brands";
import React, { useEffect, useState } from 'react';
import Layout from '../component/Layout';
import { ArrowUpTrayIcon,  EllipsisVerticalIcon, PencilIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import { addPromoCode, getCustomers, getPromoCode, updatePromo } from '../adapter/api';
import { ApiUrlService } from '../api-library/api-services';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import DatePicker from 'react-datepicker';
import './OrderModals.css';

const PromoCode = () => {

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalAddOpen, setIsModalAddOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [promoCodes, setPromoCodes] = useState([]);
  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const [code, setCode]= useState(null);
  const [amount, setAmount]= useState(null);
  const [usage, setUsage]= useState(null);
  const [active, setActive]= useState(null);
  const [expiredDate, setExpiredDate]= useState(null);
  const [publishedDate, setPublishedDate]= useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const toggleDropdown = (id) => setDropdownOpenId(dropdownOpenId === id ? null : id);
  const apiUrlService = new ApiUrlService()
  const handlePageChange = (page) => page > 0 && page <= totalPages && setCurrentPage(page);

  const handleDeleteClick = (item) => {
    toggleDropdown(null)
    setSelectedItem(item);
    setShowConfirmModal(true);
  }

  const cancelDelete = () => {
    setShowConfirmModal(false);
  };

  

  const confirmDelete = () => {
   
    handleDeleteCustomer(selectedItem);
  
  };

  const handleDeleteCustomer = async (customer) =>{
    try {

      var service = apiUrlService.DeleteApi();
      fetch(`${brand.apiBaseUrl}/promoCode/` + customer.promo_code_id + '', service).then(res => res.json())
          .then(response => {
 
              if (response.status === true) {
                toast.success("Promo Code Deleted!");
                  setShowConfirmModal(false);
                 
                  handleGetPromoCode()
              }else{
       
                toast.error("Error deleting code!");
              
              
              }
          })


    } catch (error) {
      toast.error("Error deleting item!");
      console.error("Delete error:", error);
    }
  }

  // Inside the component function
const exportToPDF = () => {
  const doc = new jsPDF();
  
  // Adding title to PDF
  doc.text("PromoCode", 20, 20);
  
  // Set up headers for the table
  const headers = ["#", "Name", "Email", "Phone No." ];
  
  // Create rows dynamically based on orders
  const rows = paginatedOrders.map(order => [
    order.promo_code_id,
    order.code,
    order.usage,
    order.active
  ]);
  
  // Add the table to the PDF
  doc.autoTable({
    head: [headers],
    body: rows,
    startY: 30, // The Y position where the table starts
  });

  // Save the PDF to the local system
  doc.save("promoCode.pdf");
};


   // Derived states
   const filteredOrders = promoCodes.filter((order) => {
    const search = searchTerm.toLowerCase();
    return (
      order.code?.toString().toLowerCase().includes(search) ||
      order.usage?.toString().toLowerCase().includes(search) ||
      order.amount?.toString().toLowerCase().includes(search) ||
      order.expiredDate?.toString().toLowerCase().includes(search) 
    );
  });

  const totalPages = Math.ceil(filteredOrders.length / rowsPerPage);
  useEffect(() => {
    setCurrentPage(page => Math.min(page, Math.max(1, totalPages)));
  }, [totalPages]);
  const paginatedOrders = filteredOrders.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page on search
  };

  const handleGetPromoCode = async () => {
    setPromoCodes([]);
    const response = await getPromoCode()
    setPromoCodes(response.data.data)
  }


  useEffect(() => {
    handleGetPromoCode()
  }, []);

  useEffect(() => {
    if (selectedCustomer) {
      setCode(selectedCustomer.code || "");
      setAmount(selectedCustomer.amount || "");
      setUsage(selectedCustomer.usage || "");
      setExpiredDate(selectedCustomer.expiredDate || "")
    }
  }, [selectedCustomer]);

  const handleSaveCustomer = async () => {

    if(code &&  amount && expiredDate){
      const response = await addPromoCode(code, usage, amount, expiredDate)
      toast.success('PromoCode Added Successfully');
      setIsModalAddOpen(false)
       handleGetPromoCode()
       setCode("")
       setUsage("")
       setAmount("")
       setExpiredDate("")
    }
    else{
      toast.error("Please complete all the required fields!")
    }
  
           
  }


  const handleEditItem = async (customer) => {
    const response = await updatePromo(code, usage, amount, expiredDate, customer.promo_code_id);
    toast.success('PromoCode updated Successfully');
    setIsModalOpen(false)
    handleGetPromoCode()
    setCode("")
    setUsage("")
    setAmount("")
    setExpiredDate("")
  };

  const handleDeleteItem = (index) => {
    console.log("Delete item at index:", index);
    // Implement the logic to delete the item
    // For example, you can update the items array:
    const updatedItems = selectedCustomer.items.filter((_, i) => i !== index);
    setSelectedCustomer({ ...selectedCustomer, items: updatedItems });
  };


  const openModal = (order) => {
    toggleDropdown(null)
    setSelectedCustomer(order); // Set the selected order to display its details
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsModalAddOpen(false)
    setSelectedCustomer(null); // Clear selected order when closing the modal
  };



  return (
    <Layout>
           <ToastContainer />
      <h1 className="text-2xl font-medium mb-4 mt-7 font-inter text-lg">Promo Code</h1>
      {/* Page content goes here */}
      <hr className="w-full" style={{ border: "1px solid var(--color-border)", margin: "10px 0" }} />

      <div className="data-card overflow-x-auto mt-4 rounded-lg">
        <div className="data-toolbar bg-grey flex justify-between items-center mb-0 w-full border-t border-l pl-3 border-r pr-3 pt-3 border-gray-200">

          <div className="w-1/3 pb-3">
          <input
          type="text"
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Search promo codes…" aria-label="Search promo codes"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
          </div>

          <div className="npb-3 flex">
            <button onClick={()=> setIsModalAddOpen(true)}
              className="mr-5 px-4 py-2 bg-yellow flex text-white font-inter text-sm font-sm rounded-lg hover:bg-customColor transition-colors"
            > <PlusIcon className="h-4 w-4 mr-2 mt-0.4" />
              New PromoCode
            </button>
            <button onClick={exportToPDF}
              className="px-4 py-2 bg-yellow flex text-white font-inter text-sm font-sm rounded-lg hover:bg-customColor transition-colors"
            > <ArrowUpTrayIcon className="h-4 w-4 mr-2 mt-0.4" />
              Export
            </button>
          </div>
        </div>
        <table className="data-table  min-w-full bg-white border-b border-r border-l border-gray-200 shadow-sm">
          <thead>
            <tr className="bg-grey border-b">
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700"></th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Code</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Active</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Amount</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Usage</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">published Date</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">expiredDate</th>
            </tr>
          </thead>
          <tbody>
            {paginatedOrders.map((order) => (
              <tr
                key={order.promo_code_id}
                className="border-b hover:bg-gray-50"
              >
                <td
                  className="px-4 py-3 text-sm text-yellow font-inter cursor-pointer"

                >
                  <EllipsisVerticalIcon className="h-5 w-5 mr-2"
                    onClick={() => toggleDropdown(order.promo_code_id)} />
                  {dropdownOpenId === order.promo_code_id && (
                    <div className="absolute bg-white shadow rounded p-2" style={{ width: "10%" }}>
                      <button className="block w-full text-left px-2 py-1 hover:text-yellow text-gray-700" onClick={() => openModal(order)}>Edit</button>
                      <hr className="w-full border-gray-200 my-2" />
                      <button className="block w-full text-left px-2 py-1 text-red-600 hover:text-yellow text-gray-700" onClick={() => handleDeleteClick(order)}>Delete</button>
                    </div>
                  )}
                </td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.code}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.active}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.amount}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.usage}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.publishedDate}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.expiredDate}</td>
              </tr>
            ))}

          </tbody>
        </table>
        {/* Pagination */}
      <div className="data-pagination bg-grey mb-0 w-full flex justify-between border-t border-l pl-3 border-r pr-3 pt-3 items-center md:flex-row justify-between pt-4">
          <span className="text-sm font-medium">
            Showing {filteredOrders.length ? (currentPage - 1) * rowsPerPage + 1 : 0}-{Math.min(currentPage * rowsPerPage, filteredOrders.length)} of{' '}
            {filteredOrders.length}
          </span>
          <TablePagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
      </div>
      <div className="data-endcap">
      

        {/* Modal */}
        {isModalOpen && selectedCustomer && (
          <div className="order-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="order-modal-panel bg-white rounded-lg shadow-lg p-6">
              <h2 className="text-lg font-semibold mb-4">PromoCode Details</h2>
              <hr className="w-full" style={{ border: "1px solid var(--color-border)", margin: "10px 0" }} />

              {/* Other Order Details */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Code</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                />

                <label className="block text-sm font-medium text-gray-700 mb-1">Usage</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  value={active}
                  onChange={(e) => setActive(e.target.value)}
                />

                <label className="block text-sm font-medium text-gray-700 mb-1">Amount</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  value={usage}
                  onChange={(e) => setUsage(e.target.value)}
                />

             
   {/* Expired Date Picker */}
   <label className="block text-sm font-medium text-gray-700 mb-1">
              Expired Date
            </label>
            <DatePicker
              selected={expiredDate}
              onChange={(date) => setExpiredDate(date)}
              showTimeSelect
              dateFormat="yyyy-MM-dd HH:mm:ss"
              placeholderText="Select Expired Date"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
            />
              </div>





              <div className="flex justify-center space-x-2">
                <button
                  className="px-5 py-1 bg-white border font-inter border-gray-700 text-gray-700 text-sm rounded-lg hover:bg-yellow hover:text-white hover:border-white "
                  onClick={() => handleEditItem(selectedCustomer)}
                >
                  SAVE
                </button>
                <button className="px-5 py-1 bg-white font-inter  border border-gray-700 text-gray-700 text-sm  rounded-lg hover:bg-yellow hover:text-white hover:border-white"
                  onClick={closeModal}>
                  CANCEL
                </button>
              </div>
            </div>
          </div>
        )}

{isModalAddOpen && (
          <div className="order-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="order-modal-panel bg-white rounded-lg shadow-lg p-6">
              <h2 className="text-lg font-semibold mb-4">Promo Code Details</h2>
              <hr className="w-full" style={{ border: "1px solid var(--color-border)", margin: "10px 0" }} />

              {/* Other Order Details */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Code</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                />

                <label className="block text-sm font-medium text-gray-700 mb-1">Amount</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />

                <label className="block text-sm font-medium text-gray-700 mb-1">Number of Usage</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  value={usage}
                  onChange={(e) => setUsage(e.target.value)}
                />

                {/* Expired Date Picker */}
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Expired Date
            </label>
            <DatePicker
              selected={expiredDate}
              onChange={(date) => setExpiredDate(date)}
              showTimeSelect
              dateFormat="yyyy-MM-dd HH:mm:ss"
              placeholderText="Select Expired Date"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
            />


              </div>





              <div className="flex justify-center space-x-2">
                <button
                  className="px-5 py-1 bg-white border font-inter border-gray-700 text-gray-700 text-sm rounded-lg hover:bg-yellow hover:text-white hover:border-white "
                  onClick={() => handleSaveCustomer()}
                >
                  SAVE
                </button>
                <button className="px-5 py-1 bg-white font-inter  border border-gray-700 text-gray-700 text-sm  rounded-lg hover:bg-yellow hover:text-white hover:border-white"
                  onClick={closeModal}>
                  CANCEL
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Confirmation Modal */}
  {showConfirmModal && (
        <div className="order-modal-backdrop fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="order-dialog-panel bg-white p-6 rounded-lg shadow-lg">
            <p className="text-lg font-semibold mb-4">
              Are you sure you want to delete this promoCode?
            </p>
            <div className="flex justify-end space-x-4">
              <button
                className="px-4 py-2 bg-gray-400 rounded hover:bg-yellow "
                onClick={cancelDelete}
              >
                No
              </button>
              <button
                className="px-4 py-2 bg-gray-400 rounded hover:bg-yellow"
                onClick={confirmDelete}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      </div>
    </Layout>
  );
};

export default PromoCode;
